<template>
    <b-container >
      <Spinner size="32" message="Loading..." v-if="isLoading"> </Spinner>
      <b-alert :show = "showDismissibleAlert" dismissible 
          @dismissed="showDismissibleAlert=false"
          :variant="variant">
          {{alertText}}
      </b-alert>
        <b-form @submit="onSubmit" @reset="onReset" v-if="show">
            <b-row class="justify-content-md-center">
                <b-col md="7" sm="12" class="mt-2">
                    <p style="font-size: 17px;color:#2284ab;">Qualification Information Details</p>
                    <p></p>
                    <div style="padding: 10px;
                            border: 2px solid #c4c6be;
                            border-radius: 15px;">
                    <b-form-group id="exampleInputGroup1" horizontal
                            label="Qualification Type <span style='color:red'>*</span>" label-size="sm"
                            label-for="exampleInput1">
                            <b-form-select id="exampleInput1"
                                :options="qualifications"
                                value-field="QualificationTypeID"
                                text-field="QualificationTypeName"
                                required size="sm"  @change.native="onChageQual"
                                v-model="form.UserQualification.QualificationTypeID">
                        </b-form-select>
                    </b-form-group>
                    <b-form-group id="exampleInputGroup2" horizontal
                            label="State <span style='color:red'>*</span>" label-size="sm"
                            label-for="exampleInput2">
                        <b-form-select id="exampleInput1"
                                :options="states"
                                value-field="StateID"
                                text-field="StateName"
                                required size="sm"  @change.native="onChangeState"
                                v-model="form.UserQualification.StateID">
                        </b-form-select> 
                    </b-form-group>
                    <b-form-group id="igp" horizontal v-if="Hdegree == '8th' || Hdegree == '1st - 4th' || Hdegree == '5th - 7th'"
                            label="School Name <span style='color:red'>*</span>" label-size="sm"
                            label-for="exampleInput3">
                        <b-form-input type="text" placeholder="Name of your school" size="sm" required
                             :formatter="format"  lazy-formatter   v-model="form.UserQualification.SchoolName"></b-form-input>    
                    </b-form-group>
                    <b-form-group id="grpDegree" horizontal v-if="Hdegree == 'University'"
                            label="Name of Degree <span style='color:red'>*</span>" label-size="sm"
                            label-for="exampleInput3">
                        <b-form-select id="inpDegree"
                                :options="degreeType"
                                value-field="DegreeTypeID"
                                text-field="DegreeName"
                                required size="sm"
                                v-model="form.UserQualification.DegreeID">
                        </b-form-select>   
                    </b-form-group>
                    <!-- --------------------start---------------------- -->

                       <b-form-group id="igp" horizontal 
                                      v-if="this.form.UserQualification.DegreeID=='00000000-0000-0000-0000-000000000000' && form.UserQualification.QualificationTypeID=='09713307-253d-4e35-aca9-50ccde3e05a6'"
                                      label="Other Qualifications " label-size="sm"
                                      label-for="exampleInput3">
                                <b-form-input type="text" placeholder="Other Qualifications" size="sm"
                                      required  v-model="form.UserQualification.OtherDegreeName"></b-form-input>    
                              </b-form-group>
                    <!-- --------------------end---------------------- -->
                    <b-form-group id="exampleInputGroup3" horizontal  v-if="Hdegree == 'University' || Hdegree == 'Board'"
                            label="Board / University <span style='color:red'>*</span>" label-size="sm"
                            label-for="exampleInput3">
                        <b-form-select id="exampleInput1"
                                :options="boards"
                                value-field="BoardID"
                                text-field="BoardName"
                                required size="sm"
                                v-model="form.UserQualification.BoardID">
                        </b-form-select>   
                    </b-form-group>
                    <b-form-group id="grpAddress" horizontal  v-if="Hdegree != 'Illiterate'"
                             label-size="sm" label="Result <span style='color:red'>*</span>">
                        <b-form-select id="exampleInput1"
                                :options="results"
                                required size="sm"
                                v-model="form.UserQualification.Result">
                        </b-form-select>
                    </b-form-group>
                    <b-form-group id="grpPrct" horizontal v-if="Hdegree != '8th' && form.UserQualification.Result ==1"
                             label-size="sm" label="Percentages <span style='color:red'>*</span>">
                        <b-form-input type="number" placeholder="% of marks" size="sm"
                            @change.native="onChangeMarks" min="0" max="100"
                                v-model="form.UserQualification.Percentage" ></b-form-input>
                    </b-form-group>
                    <b-form-group id="exampleInputGroup3" horizontal v-if="Hdegree != '8th' && form.UserQualification.Result ==1"
                            label="Class <span style='color:red'>*</span>" label-size="sm"
                            label-for="exampleInput3">
                        <b-form-input type="text" placeholder="Class in which you passed" size="sm" disabled
                             :formatter="format"  lazy-formatter   v-model="form.UserQualification.Class"></b-form-input>    
                    </b-form-group>
                    
                    </div>

                    <div>
                      <b-row class="justify-content-md-center">
                        <b-col md="12" sm="9" class="mt-2">
                          <p style="font-size: 17px;color:#2284ab;">Computer Proficiency</p>
                            <p></p>
                          <div style="padding: 10px;
                              border: 2px solid #c4c6be;
                              border-radius: 15px;">
                          
                              <b-form-radio-group v-model="form.UserQualification.ComputerProficiency"
                                                  :options="options"
                                                  text-field="Certificate"
                                                  value-field="CertificateID"
                                                  stacked
                                                  name="ComputerProficiency">
                              </b-form-radio-group>
                          
                          </div>
                        </b-col>
                      </b-row>
                    </div>

                    <div>
                      <b-row class="justify-content-md-center">
                        <b-col md="12" sm="9" class="mt-2">
                          <p style="font-size: 17px;color:#2284ab;">Other Qualification</p>
                            <p></p>
                          <div style="padding: 20px;
                              border: 2px solid #c4c6be;
                              border-radius: 15px;">
                          
                              <b-form-group id="igp" horizontal
                                      label="Other Qualifications if Any" label-size="sm"
                                      label-for="exampleInput3">
                                <b-form-input type="text" placeholder="Other Qualifications" size="sm"
                                      :formatter="format"  lazy-formatter   v-model="form.UserQualification.OtherQualifications"></b-form-input>    
                              </b-form-group>
                            
                          </div>
                        </b-col>
                      </b-row>
                    </div>
                </b-col>

            </b-row>
            
            <b-row class="mt-2 justify-content-md-center" v-if="!LockProfile">
                <b-col md="4" sm="12" style="text-align:center">
                  <Spinner size="32" message="Loading..." v-if="isLoading"> </Spinner>
                  <b-alert :show = "showDismissibleAlert" dismissible 
                      @dismissed="showDismissibleAlert=false"
                      
                      :variant="variant">
                      {{alertText}}
                  </b-alert>
                </b-col>
                <b-col  md="4" sm="12" style="text-align:right">
                  <b-button type="submit" variant="primary">Submit</b-button>
                  <b-button type="reset" variant="danger">Reset</b-button>
                  <b-button variant="secondary" @click="onClickButton" v-if="saved">Next</b-button>
                </b-col>
            </b-row>
        </b-form>
    </b-container>
</template>

<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";
import * as _ from "lodash";
export default {
  name: "PhysicalDetails",
  components: { Spinner },
  data() {
    return {
      qualifications: [],
      states: [],
      boards: [],
      degreeType: [],
      results: [{ value: 1, text: "Pass" }, { value: 2, text: "Fail" }],
      options: [
        { CertificateID: 1, Certificate: "MSCIT Certified" },
        { CertificateID: 2, Certificate: "Other Certified" },
        { CertificateID: 3, Certificate: "Can Operate Computer" },
        { CertificateID: 4, Certificate: "No Knowledge of Computer" }
      ],
      form: {
        UserQualification: {
          QualificationTypeID: "",
          DegreeID: "",
          StateID: "",
          BoardID: "",
          Result: "",
          Percentage: 0,
          Class: "NA",
          SchoolName: "",
          ComputerProficiency: 0,
          OtherQualification: "",
          OtherDegreeName: ""
        },
        LoginID: ""
      },
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      show: true,
      Hdegree: "8th",
      saved: false
    };
  },
  computed: {
    getRegType() {
      let x = this.$store.getters.getUserData;

      if (x.RegistrationType) {
        return x.RegistrationType;
      } else {
        return "";
      }
    },
    LockProfile() {
      let userinfo = this.$store.getters.getUserData;
      if (userinfo) {
        return userinfo.LockProfile;
      } else {
        return false;
      }
    }
  },
  methods: {
    format(value, event) {
      if (value) {
        return value.trim();
      }
    },
    onClickButton() {
      this.saved = false;
      this.showDismissibleAlert = false;
      this.$emit("clicked");
    },
    onChangeMarks(evt) {
      var value = this.form.UserQualification.Percentage;
      if (value < 45) {
        this.form.UserQualification.Class = "Third Class";
      } else if (value >= 45 && value < 60) {
        this.form.UserQualification.Class = "Second Class";
      } else if (value >= 60) {
        this.form.UserQualification.Class = "First Class";
      }
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.isLoading = true;
     if (this.form.UserQualification.DegreeID!='00000000-0000-0000-0000-000000000000') 
     {
      this.form.UserQualification.OtherDegreeName='';
     }
      if (
        this.getRegType != 3 &&
        this.Hdegree == "8th" &&
        (this.form.UserQualification.Result == 2 ||
          this.form.UserQualification.Result == "2")
      ) {
        this.alertText =
          "Minimum Qualification is 8th Pass, You can not apply.";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        return;
      } else if (
        this.getRegType != 3 &&
        (this.Hdegree == "Illiterate" ||
          this.Hdegree == "1st - 4th" ||
          this.Hdegree == "5th - 7th")
      ) {
        this.alertText =
          "Minimum Qualification is 8th Pass, You can not apply.";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        return;
      }
      var userinfo = this.$store.getters.loggedUser;
      this.form.LoginID = userinfo.UserId;
      let promise = apis.saveQualification(this.form);

      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.alertText = "Data Saved Successfully";
            this.saved = true;
            this.variant = "success";
            this.showDismissibleAlert = true;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    onReset() {},
    onChageQual(evt) {
      if (this.form.UserQualification.StateID != "") {
        this.getBoards(evt.target.value, this.form.UserQualification.StateID);
      }
      this.getDegrees(evt.target.value);
    },
    onChangeState(evt) {
      if (this.form.UserQualification.QualificationTypeID != "") {
        this.getBoards(
          this.form.UserQualification.QualificationTypeID,
          evt.target.value
        );
      }
    },
    getDegrees(ins) {
      let promise = apis.getDegreeTypes(ins);

      promise
        .then(response => {
          //console.log('Reponse' ,response);
          if (response.status == 200) {
            this.degreeType = response.body;
            //console.log('religion',this.religions)
            this.isLoading = false;
            //this.$router.push("/");
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    getBoards(ins, sts) {
      let q = _.filter(this.qualifications, { QualificationTypeID: ins });
      if (q) {
        //console.log(q[0].QualificationTypeName);
        var brd = "";
        if (q[0].QualificationTypeName == "8th") {
          this.Hdegree = "8th";
          return;
        } else if (
          q[0].QualificationTypeName == "SSC" ||
          q[0].QualificationTypeName == "HSC"
        ) {
          this.Hdegree = "Board";
          brd = "Board";
        } else if (
          q[0].QualificationTypeName == "Graduate" ||
          q[0].QualificationTypeName == "Post Graduate" ||
          q[0].QualificationTypeName == "Certification"
        ) {
          this.Hdegree = "University";
          brd = "University";
        } else {
          this.Hdegree = q[0].QualificationTypeName;
          return;
        }
        let promise = apis.getBoards(brd, sts);

        promise
          .then(response => {
            //console.log('Reponse' ,response);
            if (response.status == 200) {
              this.boards = response.body;
              //console.log('religion',this.religions)
              this.isLoading = false;
              //this.$router.push("/");
            } else {
              this.alertText = response.body;

              this.variant = "warning";
              this.showDismissibleAlert = true;
            }
          })
          .catch(err => {
            this.alertText = err.body;
            this.showDismissibleAlert = true;
            this.variant = "danger";
          });
      }
    }
  },
  mounted() {
    var userinfo = this.$store.getters.loggedUser;
    let promise = apis.getStates();
    let promiseQaul = apis.getQualifications();
    let promiseUserQual = apis.ReadUserQualification(userinfo.UserId);

    Promise.all([promise, promiseQaul, promiseUserQual])
      .then(values => {
        if (values[0].status == 200) {
          this.states = values[0].body;
          this.isLoading = false;
        } else {
          this.alertText = values[0].body;

          this.variant = "warning";
          this.showDismissibleAlert = true;
        }

        if (values[1].status == 200) {
          this.qualifications = values[1].body;
          this.isLoading = false;
        } else {
          this.alertText = values[1].body;

          this.variant = "warning";
          this.showDismissibleAlert = true;
        }

        if (values[2].status == 200) {
          this.form.UserQualification = values[2].body;
          this.getDegrees(values[2].body.QualificationTypeID);
          this.getBoards(
            values[2].body.QualificationTypeID,
            values[2].body.StateID
          );
          this.isLoading = false;
        } else {
          this.alertText = values[2].body;

          this.variant = "warning";
          this.showDismissibleAlert = true;
        }
        this.isLoading = false;
      })
      .catch(err => {
        this.alertText = err.body;
        this.showDismissibleAlert = true;
        this.variant = "danger";
        this.isLoading = false;
      });

    /*
    promise
      .then(response => {
        console.log('Reponse3' ,response);
        if (response.status == 200) {
          this.states = response.body;
          //console.log('religion',this.religions)

          this.isLoading = false;
          //this.$router.push("/");
        } else {
          this.alertText = response.body;

          this.variant = "warning";
          this.showDismissibleAlert = true;
        }
      })
      .catch(err => {
        this.alertText = err.body;
        this.showDismissibleAlert = true;
        this.variant = "danger";
      });

    promiseQaul
      .then(response => {
        console.log('Reponse2' ,response);
        if (response.status == 200) {
          this.qualifications = response.body;
          //console.log('religion',this.religions)
          this.isLoading = false;
          //this.$router.push("/");
        } else {
          this.alertText = response.body;

          this.variant = "warning";
          this.showDismissibleAlert = true;
        }
      })
      .catch(err => {
        this.alertText = err.body;
        this.showDismissibleAlert = true;
        this.variant = "danger";
      });

    promiseUserQual
      .then(response => {
        console.log("Reponse1", response);
        if (response.status == 200) {
          this.form.UserQualification = response.body;
          this.getDegrees(response.body.QualificationTypeID);
          this.getBoards(
            response.body.QualificationTypeID,
            response.body.StateID
          );
          //console.log('religion',this.religions)
          this.isLoading = false;
          //this.$router.push("/");
        } else {
          this.alertText = response.body;

          this.variant = "warning";
          this.showDismissibleAlert = true;
        }
      })
      .catch(err => {
        this.alertText = err.body;
        this.showDismissibleAlert = true;
        this.variant = "danger";
      });
      */
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: 0.75rem;
}
</style>



// WEBPACK FOOTER //
// src/components/RegistrationDetails/Qualification.vue